/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Form } from 'react-bootstrap';

const SearchInput = ({
  searchInputValue,
  setSearchInputValue,
  placeholder = 'Search...',
  className = 'px-3 mt-2',
  inputClassName
}) => {
  return (
    <div className={className}>
      <Form className="position-relative">
        <Form.Control
          type="search"
          placeholder={placeholder}
          aria-label="Search"
          className={classNames(inputClassName, 'rounded-3 py-2 search-input')}
          style={{ paddingLeft: '2.5rem' }}
          value={searchInputValue}
          onChange={({ target }) => setSearchInputValue(target.value)}
        />
        <FontAwesomeIcon
          icon="search"
          className="position-absolute text-400 search-box-icon"
          style={{ top: '14px', left: '1rem' }}
        />
      </Form>
    </div>
  );
};

export default SearchInput;
